// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DT EVENTS ||============================== //

export async function handleDTEvents(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/dt-events', action.data);
    case 'read':
      return getRequest(`/dt-events?dt-id=${action.id}`);
    case 'update':
      return putRequest(`/dt-events/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/dt-events/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDTEvents] - Unknown method');
      break;
  }
}
